import {
  Datagrid,
  List,
  TextField,
  Filter,
  SelectInput,
  TextInput,
  FunctionField,
  ChipField,
} from "react-admin";
import { LocalizedDateField } from "../../components/localized-date-field.component";

const AuditLogsFilter = (props: any) => (
  <Filter {...props}>
    <SelectInput
      source="action"
      label="Ação"
      choices={[
        { id: "ISSUED", name: "Emitida" },
        { id: "DOWNLOADED", name: "Baixada" },
        { id: "REVOKED", name: "Revogada" },
        { id: "VALIDATED", name: "Validada" },
        { id: "EXPIRED", name: "Expirada" },
        { id: "DEACTIVATED", name: "Desativada" },
        { id: "ACTIVATED", name: "Ativada" },
      ]}
      alwaysOn
    />
    <TextInput source="serialNumber" label="Serial Number" />
    <TextInput source="hwid" label="HWID" />
  </Filter>
);

// Custom color mapping for actions
const getActionColor = (action: string) => {
  const colors: Record<string, string> = {
    ISSUED: "#4caf50", // green
    DOWNLOADED: "#2196f3", // blue
    REVOKED: "#f44336", // red
    VALIDATED: "#ff9800", // orange
    EXPIRED: "#9e9e9e", // grey
    DEACTIVATED: "#9c27b0", // purple
    ACTIVATED: "#00bcd4", // cyan
  };
  return colors[action] || "#000";
};

// Map actions to Portuguese labels
const getActionLabel = (action: string) => {
  const labels: Record<string, string> = {
    ISSUED: "Emitida",
    DOWNLOADED: "Baixada",
    REVOKED: "Revogada",
    VALIDATED: "Validada",
    EXPIRED: "Expirada",
    DEACTIVATED: "Desativada",
    ACTIVATED: "Ativada"
  };
  return labels[action] || action;
};

export const AuditLogsList = (props: any) => {
  return (
    <List
      {...props}
      filters={<AuditLogsFilter />}
      perPage={50}
      sort={{ field: "createdAt", order: "DESC" }}
      title="Auditoria de Licenças"
    >
      <Datagrid bulkActionButtons={false}>
        <FunctionField
          label="Licença"
          render={(record: any) => {
            const serialNumber = record.license?.serialNumber || "-";
            const licenseId = record.license?.id;
            return licenseId ? (
              <a href={`/#/licenses/${licenseId}/edit`}>
                {serialNumber}
              </a>
            ) : (
              serialNumber
            );
          }}
        />

        <FunctionField
          label="Ação"
          render={(record: any) => (
            <ChipField
              record={{ action: getActionLabel(record.action) }}
              source="action"
              style={{
                backgroundColor: getActionColor(record.action),
                color: "#fff",
              }}
            />
          )}
        />

        <TextField source="ipAddress" label="Endereço IP" />

        <FunctionField
          label="User Agent"
          render={(record: any) => (
            <span title={record.userAgent}>
              {record.userAgent
                ? record.userAgent.substring(0, 50) + "..."
                : "N/A"}
            </span>
          )}
        />

        <FunctionField
          label="Serial Number"
          render={(record: any) => record.metadata?.serialNumber || "-"}
        />

        <FunctionField
          label="HWID Computador"
          render={(record: any) => (
            <span
              style={{
                display: "inline-block",
                maxWidth: 340,
                whiteSpace: "normal",
                wordBreak: "break-word",
                lineHeight: 1.2,
                overflow: "hidden",
                verticalAlign: "bottom",
              }}
              title={record.metadata?.hwid || ""}
            >
              {record.metadata?.hwid || "-"}
            </span>
          )}
          style={{ width: 340, maxWidth: 340 }}
        />

        <FunctionField
          label="Tamanho do Arquivo"
          render={(record: any) => record.metadata?.fileSize || "-"}
        />

        <FunctionField
          label="Ativações Restantes"
          render={(record: any) => record.metadata?.remainingActivations || "-"}
        />

        <FunctionField
          label="Versão do App"
          render={(record: any) => record.metadata?.appVersion || "-"}
        />

        <FunctionField
          label="ID do Usuário"
          render={(record: any) => record.metadata?.userId || "-"}
        />

        <FunctionField
          label="ID do Produto"
          render={(record: any) => record.metadata?.productId || "-"}
        />

        <FunctionField
          label="Dias de Licença"
          render={(record: any) => record.metadata?.licenseDays || "-"}
        />

        <FunctionField
          label="Expira em"
          render={(record: any) => record.metadata?.expiresAt || "-"}
        />

        <FunctionField
          label="Motivo"
          render={(record: any) => record.metadata?.reason || "-"}
        />

        <FunctionField
          label="Revogado em"
          render={(record: any) => record.metadata?.revokedAt || "-"}
        />

        <FunctionField
          label="Hash HWID Anterior"
          render={(record: any) => record.metadata?.previousHwidHash || "-"}
        />

        <FunctionField
          label="Solicitado por (Usuário)"
          render={(record: any) => record.metadata?.requestedByUserId || "-"}
        />

        <LocalizedDateField
          source="createdAt"
          label="Data/Hora"
          showTime={true}
        />
      </Datagrid>
    </List>
  );
};
